import { Component } from 'react';
import _ from 'underscore';
import { mixinsClassName, createElement, fetch, urls, dom, omitPrefix } from '../../utils';
import Download from './download';
import Preview from './preview';

const WebUploader = window.WebUploader;

/**
    type: "qiniu",
    res_host: "https://qn-im.udesk.cn/",  //上传后显示的域名地址
    up_host: "http://up.qiniu.com/",      // 上传的地址
    token:    uptoken,                    // token
    expired_at: 1.hour.ago - 20.minute,   // token过期时间
*/
let upload_cfg;

async function loadUploadCfg() {
    let res = await fetch(urls.api.upolad_token);
    if (res.ok) {
        // this.upload_cfg = res.upload;
        // resolve(res.upload);
        return res;
    } else {}
    // setTimeout(loadUploadCfg, 55 * 60 * 1000); //七牛默认3600秒
}

export class Uploader extends Component {
    state = {};

    create() {
        const { canUpload, manualUpload, onProgress, onSuccess, onError, onFinshed } = this.props;

        let uploader;
        let el = dom(this)[0];
        let props = omitPrefix(this.props, 'on');
        let keepFileQueue = (file) => {
            if (canUpload) {
                canUpload(file, () => {
                    uploader.upload(file);
                });
            } else {
                uploader.upload(file);
            }
        };

        delete props.canUpload;
        delete props.manualUpload;

        uploader = new WebUploader.Uploader(_.extend({
            auto: false,//选择文件后是否自动上传
            disableGlobalDnd: true,//禁用拖拽
            // server: upload_cfg.host,
            fileSingleSizeLimit: 16 * 1024 * 1024, //16M
            fileNumLimit: 99999, //9w+
            duplicate: true,
            resize: false,//不压缩图片
            paste:  this.props.paste || '#msg-editor-box',
        }, props, {
            // formData: _.extend({
            //     token: upload_cfg.token
            // }, props.formData),
            pick: _.extend({
                id: el,
                multiple: false
            }, props.pick)
        }));

        // uploader.on('beforeFileQueued', function(file) {
        //     uploader.option('formData', _.extend({
        //         token: upload_cfg.token
        //     }, props.formData));
        // });
        

        uploader.on('fileQueued', (file) => {
            file = this.mapFile(file);

            // let res = await fetch(urls.api.upload_info);
            let res = loadUploadCfg();
            res.then((res) => {
                upload_cfg = res.upload || {};
                if (manualUpload) {
                    manualUpload(uploader, file, () => {
                        keepFileQueue(file);
                    });
                } else {
                    keepFileQueue(file);
                }
            }, (error) => {
                console.log("token_error: " + error);
            });
        });

        uploader.on('uploadBeforeSend', (object, data, headers) => {
            switch (upload_cfg.storage_policy) {
                case 'qiniu':
                    let qiniuFilename = this.getFileName(object.file);
                    data.key = qiniuFilename;
                    data.token = upload_cfg.token;
                    let url = upload_cfg.res_host + data.key;
                    object.file.random_filename = data.key;
                    object.file.src = url
                    break;
                case 'ali':
                    data.policy = upload_cfg.policy;
                    data.OSSAccessKeyId = upload_cfg.accessid;
                    data.Signature = upload_cfg.signature;
                    let aliFilename = this.getFileName(object.file);
                    data.key = upload_cfg.dir + aliFilename;
                    object.file.random_filename = aliFilename;
                    object.file.src = `${upload_cfg.host}/${data.key}`;
                    break;
                case 'minio':
                    let minioFilename = upload_cfg.file_name;
                    object.file.random_filename = minioFilename;
                    object.file.src = `${upload_cfg.host}/${data.file_path}`;
                    _.extend(data, upload_cfg.request_fields);
                    break;
                default:
                    data.token = upload_cfg.token;
                    break;
            }
        });

        uploader.on('uploadStart', (file) => {
            uploader.options.server = upload_cfg.host;
        });

        uploader.on('uploadProgress', (file, percentage) => {
            file = this.mapFile(file);
            percentage = (percentage * 100).toFixed(1);
            percentage = percentage > 99.9 ? 99.9 : percentage;
            onProgress && onProgress(file, percentage);
        });

        uploader.on('uploadSuccess', (file, data) => {
            file = this.mapFile(file);

            file.storage_policy = upload_cfg.storage_policy;
            file.bucket = upload_cfg.bucket;
            file.dir = upload_cfg.dir;

            onSuccess && onSuccess(file);
        });

        // uploader.on('uploadComplete', (file) => {
        //     file = this.mapFile(file);
        //     onComplete && onComplete(file, data);
        // });

        uploader.on('uploadFinished', function() {
            onFinshed && onFinshed()
        });

        uploader.on('uploadError', (file, code) => {
            file = this.mapFile(file);
            onError && onError(file, code);
        });

        uploader.on('error', (error) => {
            console.log(error);
        });

        this.state.uploader = uploader;
    }

    getFileName(file = {}) {
        var name = (file.name).split('.')[0];
        var threeRandom = ('' + Math.random() * 1000000).substring(0, 3);
        return name + "_" + Math.ceil(+new Date() / 1000) + '_' + threeRandom + '.' + file.ext;
    }
    makeThumb(file, cb) {
        var uploader = this.state.uploader;
        uploader && uploader.makeThumb(file, cb);
    }
    mapFile(file) {
        file = _.clone(file);
        file.fmt_size = WebUploader.Base.formatSize(file.size);
        // file.type = file.type.indexOf('image/') === 0 ? "image" : "file";
        file.fmt_type = file.type.indexOf('image/') === 0 ? "image" : "file";
        return file;
    }

    destroy() {
        // let uploader = this.state.uploader;
        // uploader && uploader.destroy();
    }

    async componentDidMount() {
        this.destroy();
        // if (!upload_cfg) {
        //     await loadUploadCfg();
        // }
        this.create();
    }

    componentWillUnmount() {
        this.destroy();
    }

    render() {
        let children = this.children;
        let className = mixinsClassName('ui-uploader', this.props);

        return createElement.call(this, {
            className,
            children
        });
    }
}

export { Download, Preview };


// WEBPACK FOOTER //
// ./src/ui/uploader/index.js